<svelte:head>
  <title>Local Charity Needs | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-missing-attribute -->

<div class="title">Local charity needs</div>
<div class="subtitle">Help with specific resources that charities near you need.</div>

<h2 class="is-size-4 mb-5">
  <div class="field has-addons">
    <div class="control">
      <div class="select" style="font-size:1rem;">
        <select bind:value={distance}>
          <option value={1} selected={distance === 1}>1 mile</option>
          <option value={2} selected={distance === 2}>2 miles</option>
          <option value={3} selected={distance === 3}>3 miles</option>
          <option value={5} selected={distance === 5}>5 miles</option>
          <option value={10} selected={distance === 10}>10 miles</option>
          <option value={20} selected={distance === 20}>20 miles</option>
          <option value={30} selected={distance === 30}>30 miles</option>
          <option value={50} selected={distance === 50}>50 miles</option>
          <option value={100} selected={distance === 100}>100 miles</option>
          <option value={200} selected={distance === 200}>200 miles</option>
          <option value={500} selected={distance === 500}>500 miles</option>
        </select>
      </div>
    </div>
  </div>
</h2>

{#if items != undefined && items.length > 0}
  <table class="table is-fullwidth is-hoverable">
    <tbody>
      {#each items as item}
        <tr>
          <td>
            <div
              class="is-pulled-left"
              style="width:120px; height:120px; margin-right:20px;">
              <a
                href={$url('../offer/' + item.id)}
                style="display:inline-block;width:120px;">
                {#if item.data.images?.[0]}
                  <img
                    alt="Charity"
                    src={item.data.images[0]}
                    style="height:120px;width:120px;object-fit:cover;object-position:center;"
                    loading="lazy" />
                {:else}
                  <img
                    alt="Generic"
                    src="/assets/img/box.png"
                    style="height:120px;width:120px; background-color:#eee" />
                {/if}
              </a>
            </div>
            <div>
              <a href={$url('../../need/' + item.id)}>{item.data.title}</a>
            </div>
            <div class="is-line-clamp-4">{item.data.charityDetails ? item.data.charityDetails.name : ''}</div>
          </td>
          <td>
            {#if item.data.location}
              <span class="has-text-grey-light" style="white-space: nowrap;">
                {businessLocation
                  ? getDistance(
                      {
                        latitude: item.data.location.point.latitude,
                        longitude: item.data.location.point.longitude
                      },
                      {
                        latitude: businessLocation.latitude,
                        longitude: businessLocation.longitude
                      }
                    )
                  : ''}
              </span>
            {/if}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
{:else}
  <article class="message is-success">
    <div class="message-body">
      There are no charity needs in the specified area
    </div>
  </article>
{/if}

<script lang="ts">
  import _ from 'lodash';
  import { appState } from '../../../lib/appState';
  import { url } from '@sveltech/routify';
  import { geoQuery } from '../../../lib/geo';
  import geoDist from 'geo-dist';

  let allItems: Need_v1_Doc[];

  $: items = allItems
    ? allItems.filter((item) => item.data.status === 'published')
    : undefined;

  let distance = 20;

  let firebase = window.firebase;

  $: businessLocation = $appState.company?.location;

  $: if ($appState.company?.location && typeof distance !== 'undefined') {
    getNeeds($appState.company.location);
  }

  async function getNeeds(location: GeoPoint) {
    allItems = await geoQuery(
      firebase.firestore().collection('needs_v1').where('status', '==', 'published'),
      'location.point',
      location.longitude,
      location.latitude,
      distance
    );
  }

  function getDistance(point1: GeoPoint, point2: GeoPoint) {
    try {
      console.log([point1, point2]);
      const km = geoDist(
        point1.latitude,
        point1.longitude,
        point2.latitude,
        point2.longitude
      );
      console.log(km);
      const miles = km * 0.6213712; // miles
      if (miles < 1) {
        return '< 1 mile';
        // } else if (miles < 4.5) {
        //   return Number.parseFloat(miles).toFixed(1) + " miles away";
      } else {
        console.log(Math.round(miles).toString(10) + ' miles');
        return Math.round(miles).toString(10) + ' miles';
      }
    } catch (err) {
      console.log(err);
    }
  }
</script>
